// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './allowance-daily-detail.scss';

// Utils
import { getPrettyDatetime } from '../../../../common/utils/date-utils';
import { ALLOWANCE_DAILY_TYPE_100, ALLOWANCE_DAILY_TYPE_25, ALLOWANCE_DAILY_TYPE_50, ALLOWANCE_DAILY_TYPE_75, ALLOWANCE_DEFAULT_REGION, ALLOWANCE_ISLANDS_REGION, ALLOWANCE_OTHER_COUNTRY_REGION } from '../../../../common/lists/allowance';
import { InputText } from 'primereact/inputtext';

class AllowanceDailyDetailComponent extends Component {

        constructor(props) {
            super(props);
            this.state = {
                dailyEntries: [
                    { allowanceDayType: ALLOWANCE_DAILY_TYPE_25, description: this.props.t("allowances.dialog.daily.25-days-description"), numDays: 0, total: 0, unitPrice: 0 },
                    { allowanceDayType: ALLOWANCE_DAILY_TYPE_50, description: this.props.t("allowances.dialog.daily.50-days-description"), numDays: 0, total: 0, unitPrice: 0 },
                    { allowanceDayType: ALLOWANCE_DAILY_TYPE_75, description: this.props.t("allowances.dialog.daily.75-days-description"), numDays: 0, total: 0, unitPrice: 0 },
                    { allowanceDayType: ALLOWANCE_DAILY_TYPE_100, description: this.props.t("allowances.dialog.daily.complete-days-description"), numDays: 0, total: 0, unitPrice: 0 }
                ],
                region: ""
            };
        }

    componentDidMount() {
        if(this.props.allowanceDailyData.region !== null) {
            if(this.props.allowanceDailyData.region === ALLOWANCE_DEFAULT_REGION.code) {
                this.setState({ region: ALLOWANCE_DEFAULT_REGION.name });
            }

            if(this.props.allowanceDailyData.region === ALLOWANCE_ISLANDS_REGION.code) {
                this.setState({ region: ALLOWANCE_ISLANDS_REGION.name });
            }

            if(this.props.allowanceDailyData.region === ALLOWANCE_OTHER_COUNTRY_REGION.code) {
                this.setState({ region: ALLOWANCE_OTHER_COUNTRY_REGION.name });
            }
        }
        
        this.setState({
            dailyEntries: [
                { allowanceDayType: ALLOWANCE_DAILY_TYPE_25, description: this.props.t("allowances.dialog.daily.25-days-description"), numDays: this.props.allowanceDailyData.num25Days, total: this.props.allowanceDailyData.total25Days, unitPrice: this.props.allowanceDailyData.unitPrice25Days },
                { allowanceDayType: ALLOWANCE_DAILY_TYPE_50, description: this.props.t("allowances.dialog.daily.50-days-description"), numDays: this.props.allowanceDailyData.num50Days, total: this.props.allowanceDailyData.total50Days, unitPrice: this.props.allowanceDailyData.unitPrice50Days },
                { allowanceDayType: ALLOWANCE_DAILY_TYPE_75, description: this.props.t("allowances.dialog.daily.75-days-description"), numDays: this.props.allowanceDailyData.num75Days, total: this.props.allowanceDailyData.total75Days, unitPrice: this.props.allowanceDailyData.unitPrice75Days },
                { allowanceDayType: ALLOWANCE_DAILY_TYPE_100, description: this.props.t("allowances.dialog.daily.complete-days-description"), numDays: this.props.allowanceDailyData.numCompleteDays, total: this.props.allowanceDailyData.totalCompleteDays, unitPrice: this.props.allowanceDailyData.unitPriceCompleteDays }
            ]
        });
    }

    amountBodyTemplate(rowData) {

        if(rowData.price.toString().includes(".")) {
            let amountParts = rowData.price.toString().split(".");

            if(amountParts[1].length === 1) {
                return rowData.price + "0 €";
            }
            else {
                return rowData.price + " €";
            }     
        }
        else {
            return rowData.price + ".00 €";
        }
        
        return "";
    }

    render() {

        return (
            this.props.allowanceDailyData !== null ?
                <>
                    <div className="col-12 mgt-10">
                        <label><b>{this.props.t("allowances.dialog.daily.title")}</b></label>
                    </div>
                    <div className="col-12">
                        <div className="flex flex-column gap-2">
                            <label className='mgr-10' htmlFor="allowance-region">{this.props.t("allowances.dialog.daily.region")}</label>
                            <InputText disabled value={this.state.region} id="allowance-region" type="text"/>
                        </div>
                    </div>
                    <div className="col-12">
                        <DataTable value={this.state.dailyEntries} className="p-datatable-gridlines" showGridlines rows={12} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("allowances.messages.no-dailies")}>
                            <Column field="description" header={this.props.t("allowances.dialog.daily.description-header")} />
                            <Column field="unitPrice" header={this.props.t("allowances.dialog.daily.unit-price-header")} body={(data) => this.amountBodyTemplate({ price: data.unitPrice })} style={{ maxWidth: '120px' }}  />
                            <Column field="numDays" header={this.props.t("allowances.dialog.daily.num-days-header")} />
                            <Column field="total" header={this.props.t("allowances.dialog.daily.total-header")} body={(data) => this.amountBodyTemplate({ price: data.total })} />
                        </DataTable>
                    </div>
                </>
            : null  
        );
    }
}

export default withTranslation(AllowanceDailyDetailComponent);